/**
 * dockview activates a tab on `pointerdown` unless the event is
 * `defaultPrevented` (`tabs.js` `onPointerDown` / `onTabClick`). Its own
 * default close button calls `preventDefault` on pointerdown; a custom close
 * that only `stopPropagation`s `click`/`mousedown` still lets the panel
 * become active for one frame before close — a visible flash when the user
 * was looking at a sibling (e.g. the editor singleton).
 */
export function suppressDockviewTabActivation(
  event: Pick<Event, 'preventDefault' | 'stopPropagation'>,
): void {
  event.preventDefault();
  event.stopPropagation();
}
